import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  markToCompleteWhenFinishedTalking,
  setPostObjectivesCompletePromptActive,
  virtualHumanTalkingSelector,
} from '../../slices/chat/ChatSlice';
import { objectiveGroupsCompleteSelector } from '../../slices/ObjectivesSlice';
import { objectiveGroupsWithObjectivesAndPointsSelector } from '../../slices/PatientSlice';
import { virtualHumanDataSelector } from '../../slices/VirtualHumanSlice';

const useEndSessionOnObjectivesCompleted = () => {
  const dispatch = useDispatch();
  const objectiveGroupsWithObjectivesAndPoints = useSelector(
    objectiveGroupsWithObjectivesAndPointsSelector
  );
  const completedObjectiveGroups = useSelector(objectiveGroupsCompleteSelector);
  const vh = useSelector(virtualHumanDataSelector);
  const vhTalking = useSelector(virtualHumanTalkingSelector);
  const completionCodeHitRef = useRef(false);
  // complete if all objectives completed (and objectives exist)
  useEffect(() => {
    if (
      !completionCodeHitRef.current &&
      objectiveGroupsWithObjectivesAndPoints.length > 0 &&
      objectiveGroupsWithObjectivesAndPoints.every((grp) =>
        completedObjectiveGroups.includes(grp.id)
      )
    ) {
      if (vh.Type !== 'branching') {
        completionCodeHitRef.current = true;
        if (vhTalking) {
          dispatch(markToCompleteWhenFinishedTalking());
        } else {
          dispatch(setPostObjectivesCompletePromptActive(true));
        }
      }
    }
  }, [
    objectiveGroupsWithObjectivesAndPoints,
    completedObjectiveGroups,
    dispatch,
    vh?.ExternalID,
    vh?.Type,
    vhTalking,
  ]);
};

export default useEndSessionOnObjectivesCompleted;
